// @ts-strict-ignore
import { Features } from '@backend/lib-feature-mgr';
import { openConsentManager } from '@iziwork/consent-manager';
import { styled } from 'styled-components';

import { FooterMenuItem } from '~/components/Footer/footerMenuItem';
import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { useCheckFeatureEnabled, useGetDomainPublicUrl, useIsPromanBusinessUnit, useTranslation } from '~/hooks';
import { useBrandName } from '~/hooks/useBrandName';
import { useHref } from '~/hooks/useHref';
import { getMediaQuery } from '~/utils/responsive/media';

const StyledFooterLegalMenu = styled.div<{ $isProman?: boolean }>`
  display: flex;
  justify-content: space-between;

  ${getMediaQuery('mobile')} {
    flex-direction: column;
    gap: 16px;
  }
`;

const StyledFooterLegalMenuItem = styled(FooterMenuItem)`
  padding: 0 4px;

  ${getMediaQuery('mobile')} {
    text-align: center;
  }
`;

export const FooterLegalMenu = () => {
  const t = useTranslation();
  const brandName = useBrandName();
  const { getPageHref } = useHref();
  const isProman = useIsPromanBusinessUnit();
  const getPublicUrl = useGetDomainPublicUrl();
  const { businessUnit } = useBusinessUnitContext();
  const isSEOEnabled = useCheckFeatureEnabled(Features.JobBoardSEO);

  return (
    <StyledFooterLegalMenu>
      <StyledFooterLegalMenuItem>© {brandName}</StyledFooterLegalMenuItem>
      {isProman ? (
        <>
          <StyledFooterLegalMenuItem href="https://www.proman-emploi.fr/cgu">
            {t('footer.usage_conditions')}
          </StyledFooterLegalMenuItem>
          <StyledFooterLegalMenuItem href="https://www.proman-emploi.fr/politique-de-cookies">
            {t('footer.cookies_policy')}
          </StyledFooterLegalMenuItem>
          <StyledFooterLegalMenuItem href="https://www.proman-emploi.fr/vos-droits-rgpd">
            {t('footer.rgpd')}
          </StyledFooterLegalMenuItem>
        </>
      ) : (
        <>
          <StyledFooterLegalMenuItem href={getPublicUrl('usageConditions')}>
            {t('footer.usage_conditions')}
          </StyledFooterLegalMenuItem>
          <StyledFooterLegalMenuItem href={getPublicUrl('legalMentions')}>
            {t('footer.legal_mentions')}
          </StyledFooterLegalMenuItem>
          <StyledFooterLegalMenuItem href={getPublicUrl('confidentiality')}>
            {t('footer.confidentiality')}
          </StyledFooterLegalMenuItem>
          {businessUnit === 'FR' && (
            <StyledFooterLegalMenuItem href={getPublicUrl('cookie')}>
              {t('footer.cookies_policy')}
            </StyledFooterLegalMenuItem>
          )}
          <StyledFooterLegalMenuItem onClick={openConsentManager}>
            {t('footer.cookies_settings')}
          </StyledFooterLegalMenuItem>
          <StyledFooterLegalMenuItem href={getPublicUrl('personalData')}>
            {t('footer.personalData')}
          </StyledFooterLegalMenuItem>
          {isSEOEnabled && (
            <StyledFooterLegalMenuItem href={getPageHref('sitemap')}>
              {t('footer.sitemap', { defaultValue: 'Sitemap' })}
            </StyledFooterLegalMenuItem>
          )}
        </>
      )}
    </StyledFooterLegalMenu>
  );
};
